<sh-summary-line-chart
  class="selected-tag-box__line-chart"
  [legend]="lineGraphLegend"
  [chartData]="graphInfo"
  (handleTooltipPress)="navigateToLogs($event)"
></sh-summary-line-chart>
